import { Collapse, IconButton, InputAdornment, TextField } from '@material-ui/core';
import { FilterList } from '@material-ui/icons';
import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';

export type Search = {
    query: string;
    setQuery: React.Dispatch<React.SetStateAction<string>>;
    setCollapseAdvancedSearch?: React.Dispatch<React.SetStateAction<boolean>>;
    onClickSearch: () => void;
}

export function Search({
    query,
    setQuery,
    setCollapseAdvancedSearch,
    onClickSearch
} :Search) {
    function handleChangeSearchField(value: string) {
        setQuery(value);
    }

    // useEffect(() => {
    //     onClickSearch();
    // }, [query])

    return (
        <div className="d-flex align-items-center">
            <TextField
                size="small"
                label="Pesquisar"
                margin="normal"
                variant="standard"
                value={query}
                onChange={(e) => handleChangeSearchField(e.target.value)}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                edge="end"
                                aria-label="Search"
                                onClick={onClickSearch}
                                className="mb-2"
                            >
                                <i className="flaticon2-search"></i>
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
            />
            {setCollapseAdvancedSearch && (
                <Button
                    size="sm"
                    variant="light"
                    title="Busca avançada"
                    className="ml-3 mt-5"
                    onClick={() => setCollapseAdvancedSearch((prevState) => !prevState)}
                >
                    <i className="fas fa-filter p-0"></i>
                </Button>
            )}
        </div>
    )
}